import messages from './messages';

export const orderReportSortings = [
  {
    messageDescriptor: messages.orderDateFirst,
    value: 'OrderDate desc',
  },
  {
    messageDescriptor: messages.orderDateLast,
    value: 'OrderDate asc',
  },
  {
    messageDescriptor: messages.datePaidFirst,
    value: 'PayDate desc',
  },
  {
    messageDescriptor: messages.datePaidLast,
    value: 'PayDate asc',
  },
  {
    messageDescriptor: messages.recipientNameAsc,
    value: 'ShipName asc',
  },
  {
    messageDescriptor: messages.recipientNameDesc,
    value: 'ShipName desc',
  },
  {
    messageDescriptor: messages.orderNumberAsc,
    value: 'OrderNumber asc',
  },
  {
    messageDescriptor: messages.orderNumberDesc,
    value: 'OrderNumber desc',
  },
  {
    messageDescriptor: messages.itemSkuAsc,
    value: 'ItemSku asc',
  },
  {
    messageDescriptor: messages.itemSkuDesc,
    value: 'ItemSku desc',
  },
  {
    messageDescriptor: messages.itemNameAsc,
    value: 'ItemName asc',
  },
  {
    messageDescriptor: messages.itemNameDesc,
    value: 'ItemName desc',
  },
];
